import styled, { css } from 'styled-components';
import { primaryText, smallParagraph } from '../../../../../../theme/typography';
import { themeColor } from '../../../../../../theme/getters';
import { Icon, ICON_MINUS, ICON_PLUS } from '../../../../../../shared/components/icon';

export const Container = styled.div`
  height: 74px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Label = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const Counter = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Count = styled.span`
  display: inline-block;
  min-width: 50px;
  margin-left: 16px;
  margin-right: 16px;
`;

export const Price = styled.label`
  ${primaryText};
  font-size: 20px;
  line-height: 27px;
`;

export const Age = styled.span`
  ${smallParagraph};
  color: ${themeColor('gray')};
`;

export const IconPlus = styled(Icon).attrs(() => ({
  name: ICON_PLUS,
  size: 24,
  stroked: true,
}))`
  cursor: pointer;
  ${props =>
    props.disabled &&
    css`
      pointer-events: none;
      opacity: 0.25;
    `}
`;

export const IconMinus = styled(Icon).attrs(() => ({
  name: ICON_MINUS,
  size: 24,
  stroked: true,
}))`
  cursor: pointer;
`;
